import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import BalanceInputs from '../../NestedInputs/BalanceInputs';
import { FormikNumber } from '../../../../components';

export default function SummaryDiscounts({ discounts, dispatch, viewOnly }) {
  const { values, errors } = useFormikContext();
  const totalDiscounts = values?.settlement?.settlementBalancesAttributes.reduce((acc, current) => {
    return acc + +current.amount;
  }, 0);
  return (
    <>
      <Row className="summary__balances_header small">
        <Col md={6} className="">
          <strong>Descuentos</strong>
        </Col>
        <Col className="col-1 " />
      </Row>
      <Row>
        <Col xl={12} xs={12} md={12} lg={12} style={{ textAlign: 'center' }}>
          <BalanceInputs
            isVariable={false}
            variable="settlement"
            subVariable="settlementBalancesAttributes"
            balanceType="discount"
            dispatch={dispatch}
            discounts={discounts}
            allValuesAttributes={values?.settlement?.settlementBalancesAttributes}
            canCreate={!viewOnly}
            canDestroy={!viewOnly}
            createOnClick={!viewOnly}
          />
        </Col>
      </Row>
      <Row>
        <Col xl={11} xs={12} className="d-flex p-0">
          <Col xl={3} md={3} lg={3} xs={12}>
            <FormikNumber value={totalDiscounts} abbr label="Total" decimalScale={2} readOnly leftAddon="$" />
          </Col>
        </Col>
      </Row>
      <Row>
        <Col xl={12} xs={12} md={12} lg={12} style={{ textAlign: 'center' }}>
          {errors.settlement?.settlementBalancesAttributes && (
            <Col xl={12} xs={12} md={12} lg={12} style={{ marginBottom: 10, textAlign: 'center' }}>
              {typeof errors.settlement?.settlementBalancesAttributes === 'string' && (
                <Form.Text className="text-danger">
                  <strong>{errors.settlement.settlementBalancesAttributes}</strong>
                </Form.Text>
              )}
            </Col>
          )}
        </Col>
      </Row>
    </>
  );
}
